export const environment = {
  production: true,
  enableLogging: false,
  baseUrl: '',
  baseUrlLogin: '',
  baseUrlCallback: '',
  process: 'aaa',
  hmr: false,
  visaSrcUrl: 'https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visaSdk.js',
  srciDpaId: 'Adumo_SrcI-Adumo_DPA',
  srcInitiatorId: '96MNN9MNLFOO28LDUMVF21po_gJkEWIz_mWQbl1sgp_FRp51s',
  googlePayMerchantId: 'BCR2DN4T26CMN6RE',
  googlePayMerchantName: 'Adumo Online',
  googlePayEnvironment: 'PRODUCTION',
  // applePayValidationURL: 'https://apple-pay-gateway-cert.apple.com/paymentservices/paymentSession'
  applePayValidationURL: 'https://apple-pay-gateway.apple.com/paymentservices/paymentSession',
  applePayInitiativeContext: 'https://gateway.adumoonline.com'
};
